export default function (start, stop, step = 1) {
  return Array.from(
    { length: (stop - start) / step + 1 },
    (value, index) => start + index * step,
  )
}
